import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import style from './icon-button.module.less';

import type { IconButtonComponent } from './icon-button.types';

export const IconButton: IconButtonComponent = ({ className = '', ariaLabelMessageDescriptor, icon, isActive = false, ...rest }) => {
  const intl = useIntl();

  return (
    <Button
      ariaLabel={intl.formatMessage(ariaLabelMessageDescriptor)}
      className={classnames(style['icon-button'], { [style['button-active']]: isActive }, className)}
      theme={THEME_CONSTANTS.unstyled}
      {...rest}
    >
      <FontAwesomeIcon className={style.icon} icon={icon} />
    </Button>
  );
};
